import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';
import {compose} from 'redux';
import DOMUtils from '@spothero/utils/dom';
import GTMUtils from 'utils/gtm';
import withConfig from 'config/withConfig';
import SHLoader from 'common/loader/SHLoader';
import {updateSelected, getAirportTravelDistance} from 'spot/spot-actions';
import {fetchRates} from 'checkout/checkout-actions';
import {push} from 'router/router-actions';
import {updateTimes} from 'search-request/search-request-actions';
import ExperimentUtils from 'utils/experiment';
import SHUtils from 'utils/sh-utils';
import SpotDetailsAirportContentOld from './SpotDetailsAirportContentOld';
import SpotDetailsAirportContentRedesign from './SpotDetailsAirportContentRedesign';

class SpotDetailsAirport extends Component {
    static propTypes = {
        isMobile: PropTypes.bool.isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                spotId: PropTypes.string,
            }),
        }).isRequired,
        currencyType: PropTypes.string,
        spot: PropTypes.object,
        isMonthly: PropTypes.bool,
        starts: PropTypes.string,
        ends: PropTypes.string,
        updateSelectedSpot: PropTypes.func,
        updateSearchTimes: PropTypes.func,
        getSpotToAirportTravelDistance: PropTypes.func,
        fetchAirportRates: PropTypes.func,
        isLoading: PropTypes.bool,
        pushTo: PropTypes.func,
        isAirportRateUnavailable: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this._userUnsubmitted = false;
        this._spotId = parseInt(props.match.params.spotId, 10);
        this._isAirportSpotDetailsRedesignEnabled = ExperimentUtils.isFeatureEnabled(
            'airport_spot_details_dec19'
        );
        this._spotDetailsContentComponent = this
            ._isAirportSpotDetailsRedesignEnabled
            ? SpotDetailsAirportContentRedesign
            : SpotDetailsAirportContentOld;
    }

    componentDidMount() {
        const {starts, ends, fetchAirportRates} = this.props;

        fetchAirportRates({
            spotId: this._spotId,
            starts,
            ends,
            airport: true,
            meta: {
                dateTimeChanged: true,
            },
        });

        this._searchPageContainer = DOMUtils.el('body');
        this._bodyClasses = SHUtils.determineInitialLoadBodyClasses({
            isAirport: true,
            isAirportSpotDetailsRedesign: this
                ._isAirportSpotDetailsRedesignEnabled,
            pageType: 'facility',
        });

        DOMUtils.addClass(this._searchPageContainer, this._bodyClasses);

        GTMUtils.push({
            event: 'pageview',
            page: 'spotdetail-airport',
        });

        SHUtils.staticScrollTo();
    }

    componentDidUpdate(prevProps) {
        const {spot, getSpotToAirportTravelDistance} = this.props;
        const {spot: prevSpot} = prevProps;

        if (!prevSpot && spot) {
            getSpotToAirportTravelDistance(spot).catch(error => {
                // silently catch this error to ignore errors being logged
            });
        }
    }

    componentWillUnmount() {
        DOMUtils.removeClass(this._searchPageContainer, this._bodyClasses);
    }

    _onCheckoutClick = () => {
        const {
            spot: {
                selectedRate: {fullUrl},
            },
            pushTo,
        } = this.props;

        pushTo(fullUrl);
    };

    render() {
        const {
            isMobile,
            currencyType,
            spot,
            isMonthly,
            starts,
            ends,
            updateSearchTimes,
            fetchAirportRates,
            isLoading,
            pushTo,
            isAirportRateUnavailable,
            updateSelectedSpot,
        } = this.props;
        let facility = null;
        let selectedRate = null;
        let distanceInMiles = null;
        let comparisons = null;

        if (spot) {
            facility = spot.facility;
            selectedRate = spot.selectedRate;
            distanceInMiles = spot.distanceInMiles;
            comparisons = spot.comparisons;
        }

        if (isLoading || !facility) {
            return <SHLoader className="SpotDetailsAirport-loader" />;
        }

        return (
            <div className="SearchAirport">
                <Helmet>
                    <meta name="robots" content="noindex, follow" />
                </Helmet>
                <this._spotDetailsContentComponent
                    isMobile={isMobile}
                    currencyType={currencyType}
                    isMonthly={isMonthly}
                    starts={starts}
                    ends={ends}
                    facility={facility}
                    comparisons={comparisons}
                    distanceInMiles={distanceInMiles}
                    selectedRate={selectedRate}
                    updateSearchTimes={updateSearchTimes}
                    fetchAirportRates={fetchAirportRates}
                    pushTo={pushTo}
                    isAirportRateUnavailable={isAirportRateUnavailable}
                    updateSelectedSpot={updateSelectedSpot}
                    onCheckoutClick={this._onCheckoutClick}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        checkout: {
            currencyType,
            isPurchasing,
            isFetchingRates,
            isAirportRateUnavailable,
            checkoutError,
            rid,
            promoCode,
            previousRental,
            recommendedSpotsUnavailableReason,
            showChangeDateTimeModal,
            changeDateTimeModalTitle,
            changeDateTimeModalIntroMessage,
            showRecommendedSpotsModal,
            showRedundantMonthlyReservationModal,
            redundantMonthlyReservationModalDate,
            redundantMonthlyReservationModalParkingPassURL,
            showWhyTimeExtendedModal,
            purchaseForCustomer,
            isRebookingReservation,
            changedDateTimeCount,
        },
        city: {
            data: {
                phone_number: phoneNumber,
                phone_number_friendly: phoneNumberFriendly,
                monthly_phone_number: monthlyPhoneNumber,
                monthly_phone_number_friendly: monthlyPhoneNumberFriendly,
                display_name: cityDisplayName,
            },
        },
        searchRequest: {
            monthly,
            airport,
            starts,
            ends,
            latitude,
            longitude,
            eid,
        },
        spot: {
            selected,
            showRateDetailsModal,
            rateDetailsModalSection,
            showOversizedFeeDetailsModal,
            showOnlineCommuterRateModal,
        },
    } = state;

    return {
        isLoading: isFetchingRates,
        isPurchasing,
        checkoutError,
        isMonthly: monthly,
        isAirport: airport,
        starts,
        ends,
        latitude,
        longitude,
        eventId: eid,
        rid,
        promoCode,
        previousRental,
        spot: selected,
        currencyType,
        showChangeDateTimeModal,
        changeDateTimeModalTitle,
        changeDateTimeModalIntroMessage,
        showRateDetailsModal,
        rateDetailsModalSection,
        showOversizedFeeDetailsModal,
        showOnlineCommuterRateModal,
        phoneNumber,
        phoneNumberFriendly,
        monthlyPhoneNumber,
        monthlyPhoneNumberFriendly,
        cityDisplayName,
        recommendedSpotsUnavailableReason,
        showRecommendedSpotsModal,
        showRedundantMonthlyReservationModal,
        redundantMonthlyReservationModalDate,
        redundantMonthlyReservationModalParkingPassURL,
        showWhyTimeExtendedModal,
        purchaseForCustomer,
        isRebookingReservation,
        changedDateTimeCount,
        isAirportRateUnavailable,
    };
};

const mapDispatchToProps = {
    updateSelectedSpot: updateSelected,
    fetchAirportRates: fetchRates,
    getSpotToAirportTravelDistance: getAirportTravelDistance,
    updateSearchTimes: updateTimes,
    pushTo: push,
};

const enhance = compose(
    withConfig(['isMobile']),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
);

export default enhance(SpotDetailsAirport);
